import React, { useState } from 'react'

import axios from 'axios'
import { Link ,useNavigate} from 'react-router-dom'


function SingUp() {


    const [name,setName]=useState('')
    const [mobile,setMobile]=useState('')
    const [email,setEmail]=useState('')
    const [password,setPassword]=useState('')
    
  
  
  
    const navigate=useNavigate()
  
        const handleAPI=(e)=>{
            e.preventDefault()
             axios.post('https://tinkus.onrender.com/signup',{
              name:name,
              email: email,
              mobile: mobile,
              password: password,
             
             })
             .then((result)=>{
              console.log(result)
              alert("Create SuccessFully")
              navigate('/login')
             })
            .catch((err)=>{
              console.log(err)
      
              alert(err.response.data.msg)
            })
  
  
        }
  
  


















    return (
        <div>
         <h1><Link to='/login'> <button className='btn btn bg-warning'>Login</button></Link></h1>
            <div className="container">
            
                <form action="/action_page.php">

                <div class="mb-3 mt-3">
                        <label for="email" class="form-label">Name:</label>
                        <input onChange={(e)=>setName(e.target.value)} type="text" class="form-control" id="email" placeholder="Enter Name" name="email" />
                    </div>

                    <div class="mb-3 mt-3">
                        <label for="email" class="form-label">Mobile:</label>
                        <input onChange={(e)=>setMobile(e.target.value)} type="text" class="form-control" id="email" placeholder="Enter Name" name="email" />
                    </div>


                    <div class="mb-3 mt-3">
                        <label for="email" class="form-label">Email:</label>
                        <input onChange={(e)=>setEmail(e.target.value)} type="text" class="form-control" id="email" placeholder="Enter Mobile" name="email" />
                    </div>


                    <div class="mb-3">
                        <label for="pwd" class="form-label">Password:</label>
                        <input onChange={(e)=>setPassword(e.target.value)} type="password" class="form-control" id="pwd" placeholder="Enter password" name="pswd" />
                    </div>
                   
                    <button onClick={handleAPI} type="submit" class="btn btn-primary">Submit</button>
                </form>


            </div>



        </div>
    )
}

export default SingUp
